import React from "react";
import styles from "./Loader.module.scss";

const Loader = ({ className, textColor }) => {
    return (
        <div className={`${styles.wrapperLoader}`}>
            <Loading className={className} textColor={textColor} />
        </div>
    );
};

export const Loading = ({ className ,textColor}) => (
    <div
        className={`${styles.buttonLoader} ${styles.spinner} ${className}`}
        style={textColor && { borderTopColor: textColor }}
    />
);

export default Loader;